'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@slate-editor/utils');

var _UnderlineUtils = require('./UnderlineUtils');

var UnderlineKeyboardShortcut = function UnderlineKeyboardShortcut(event, change) {
  if (_utils.keyboardEvent.isMod(event) && event.key === 'u') return (0, _UnderlineUtils.underlineMarkStrategy)(change);
  return;
};

exports.default = UnderlineKeyboardShortcut;